import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { DownloadIcon, DownloadButton } from '../../styled';
import Dropdown from './Dropdown';
import { selectIsExportingCSV } from 'store/Manage/selectors';
import Wrapper from './styled';

const ExportCSV = () => {
  const wrapperRef = useRef();
  const [showDropdown, setShowDropdown] = useState(false);
  const isExportingCSV = useSelector(selectIsExportingCSV);

  return (
  <Wrapper ref={ wrapperRef }>
      <DownloadButton disabled={ isExportingCSV } title={ isExportingCSV ? 'Exporting CSV' : 'Download' } onClick={ () => setShowDropdown(!showDropdown) }>
        <DownloadIcon />
      </DownloadButton>
      { showDropdown && <Dropdown showDropdown={ showDropdown } setShowDropdown={ setShowDropdown } wrapperRef={ wrapperRef } /> }
  </Wrapper>
  );
};

export default ExportCSV;
